/* eslint-disable no-console */
/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {App} from 'App'
import LoginPage from 'module/auth/Login'
import VerifyMobileNoPage from 'module/auth/verify-account/VerifyMobileNo'
import VerifyAcOTPPage from 'module/auth/verify-account/OTP'
import VerifyAcThankYouPage from 'module/auth/verify-account/ThankYouPage'
import RegisterPage from 'module/auth/Register'
import UnauthenticatedRouteGuard from 'routing/UnauthenticatedRouteGuard'
import ThankYouPage from 'module/auth/ThankYouPage'
import ErrorsPage from 'module/errors/ErrorsPage'
import {FC} from 'react'
import {
 Routes,
 Route,
 BrowserRouter,
 Navigate,
} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import OtpPage from 'module/auth/OTP'
import {useAuth} from 'context/AuthProvider'
import {LayoutSplashScreen} from 'layout/master-layout'
import {ScrollTop} from 'layout/components/ScrollTop'
import {MasterLayout} from '../layout/MasterLayout'
import PrivacyPolicyWrapper from 'module/public-pages/PrivacyPolicy'
import TermsOfUseWrapper from 'module/public-pages/TermsOfUse'
import CodeOfConductWrapper from 'module/public-pages/CodeOfConduct'
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
 const {isAuthReady, isAuthenticated} = useAuth()
 if (!isAuthReady) {
  return <LayoutSplashScreen />
 }
 return (
  <BrowserRouter basename={PUBLIC_URL}>
   <ScrollTop />
   <Routes>
    <Route element={<App />}>
     <Route path='error/*' element={<ErrorsPage />} />
     {isAuthenticated ? (
      <>
       <Route path='/*' element={<PrivateRoutes />} />
       <Route
        index
        element={<Navigate to='/home-page' />}
       />
       <Route
        path='privacy-policy'
        element={<PrivacyPolicyWrapper />}
       />
      </>
     ) : (
      <Route element={<MasterLayout />}>
       {/* all path redirect to /auth */}
       <Route
        path='*'
        element={<UnauthenticatedRouteGuard />}
       />
       <Route
        path='auth/*'
        element={<UnauthenticatedRouteGuard />}
       />
       <Route path='login' element={<LoginPage />} />
       <Route path='register' element={<RegisterPage />} />
       <Route path='thank-you' element={<ThankYouPage />} />
       <Route path='reg' element={<VerifyMobileNoPage />} />
       <Route
        path='verify-ac-otp-page'
        element={<VerifyAcOTPPage />}
       />
       <Route
        path='verify-ac-thank-you-page'
        element={<VerifyAcThankYouPage />}
       />
       <Route
        path='privacy-policy'
        element={<PrivacyPolicyWrapper />}
       />
       <Route
        path='terms-of-use'
        element={<TermsOfUseWrapper />}
       />
       <Route
        path='code-of-conduct'
        element={<CodeOfConductWrapper />}
       />
       <Route
        path='otp-verification'
        element={<OtpPage />}
       />
      </Route>
     )}
    </Route>
   </Routes>
  </BrowserRouter>
 )
}

export {AppRoutes}
